import PublicLayout from "@/components/PublicLayout";
import { Link } from "react-router-dom";
import { ShieldCheck, Wind, Compass, Users, ArrowRight } from "lucide-react";

export default function About() {
  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pt-20 pb-12">
        <div className="label-overline mb-4">About</div>
        <h1 className="font-display text-5xl lg:text-6xl font-bold tracking-tight max-w-4xl">
          A general contractor built for the <span style={{color:'var(--accent)'}}>Coastal Bend.</span>
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 pb-20">
        <div className="lg:col-span-7">
          <div className="rounded-2xl overflow-hidden aspect-[16/10] mb-8">
            <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="Coastal Bend home" className="w-full h-full object-cover" />
          </div>
          <h2 className="font-display text-3xl font-bold mb-4">Local. Licensed. Accountable.</h2>
          <div className="space-y-4 text-base leading-relaxed" style={{color:'var(--text-muted)'}}>
            <p>
              Coastal Bend Contractor Co. is a Corpus Christi–based residential general contractor serving Nueces County, Aransas County, and the surrounding Gulf Coast. We specialize in custom new construction, kitchen and bath remodels, and whole-home renovations engineered to handle salt air, hard storms, and Texas heat.
            </p>
            <p>
              We&rsquo;re a small, hands-on shop. The same crew that bids your project is the crew that builds it — and the owner is on every site, every week. No call centers, no subcontractor finger-pointing, no surprise change orders.
            </p>
            <p>
              From Padre Island bayfront elevations to Flour Bluff renovations and Rockport rebuilds, our work is built to last on the Coastal Bend.
            </p>
          </div>
        </div>

        <aside className="lg:col-span-5">
          <div className="grid grid-cols-1 gap-4">
            {[
              { icon: ShieldCheck, t: "Licensed & insured", d: "Fully bonded Texas general contractor with liability and workers&rsquo; comp coverage on every job." },
              { icon: Wind, t: "Coastal-grade engineering", d: "Hurricane-rated windows, impact glass, standing-seam metal roofs, and elevated builds where it matters." },
              { icon: Compass, t: "Local to the Coastal Bend", d: "Born and based in Corpus Christi. We know the city codes, lot conditions, and Gulf weather firsthand." },
              { icon: Users, t: "Owner-led teams", d: "Small crews, weekly client walkthroughs, and one accountable point of contact from start to finish." },
            ].map((b) => (
              <div key={b.t} className="card p-6">
                <div className="w-10 h-10 rounded-md flex items-center justify-center mb-4" style={{background: 'rgba(212,163,115,0.1)'}}>
                  <b.icon size={18} style={{color:'var(--accent)'}}/>
                </div>
                <div className="font-display text-lg font-bold mb-1.5">{b.t}</div>
                <p className="text-sm leading-relaxed" style={{color:'var(--text-muted)'}} dangerouslySetInnerHTML={{__html: b.d}} />
              </div>
            ))}
          </div>
        </aside>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-20">
        <div className="card p-10 lg:p-14 text-center">
          <h2 className="font-display text-3xl lg:text-5xl font-bold tracking-tight mb-4">Serving the entire Coastal Bend.</h2>
          <p className="max-w-xl mx-auto mb-8 text-base" style={{color:'var(--text-muted)'}}>
            Corpus Christi · Portland · Ingleside · Aransas Pass · Rockport · Flour Bluff · North Padre Island · Port Aransas · Robstown
          </p>
          <Link to="/contact" className="btn-primary" data-testid="about-cta-quote">Start your project <ArrowRight size={16}/></Link>
        </div>
      </section>
    </PublicLayout>
  );
}
